import React from "react";
import { notification } from "antd";
import { FaCheck, FaExclamationTriangle, FaInfo, FaMinusCircle } from "react-icons/fa";

notification.config({
  placement: 'top',
});

function formatMessage(message) {
  if (typeof message !== "string" || !message.includes("\n")) {
    return message;
  }

  return React.createElement(
    "div",
    { style: { whiteSpace: "pre-line" } },
    message
  );
}

export function success_message(message) {
  notification.success({
    message: formatMessage(message),
  });
}

export function info_message(message) {
  notification.info({
    message: formatMessage(message),
  });
}

export function warning_message(message) {
  notification.warning({
    message: formatMessage(message),
  });
}

export function error_message(message) {
  notification.error({
    message: formatMessage(message),
  });
}

export class NotificationMessagesV2 {
  static successMessage(message) {
    notification.success({
      message: formatMessage(message),
    });
  }

  static errorMessage(message) {
    notification.error({
      message: formatMessage(message),
    });
  }
}
